import { SideNavigation } from '@cloudscape-design/components';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const Navigation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <SideNavigation
      activeHref={location.pathname}
      header={{ href: '/', text: 'Game board companion' }}
      onFollow={(event) => {
        if (!event.detail.external) {
          event.preventDefault();
          navigate(event.detail.href);
        }
      }}
      items={[
        {
          type: 'section',
          text: 'Players',
          items: [{ type: 'link', text: 'Players', href: '/players' }],
        },
        {
          type: 'section',
          text: 'Game Score Counter',
          items: [
            { type: 'link', text: 'Current Game', href: '/gc/current-game' },
          ],
        },
      ]}
    />
  );
};
